import { MDBCol, MDBContainer, MDBRow, MDBBtn,MDBIcon} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { routeData } from "../data";

const AnnotationSync = ( ) => {
  const [content, setContent] = useState();
  const [imageError, setImageError] = useState(false);
  const [activeAnnotation, setActiveAnnotation] = useState();
  const [currentAnnotation, setCurrentAnnotation] = useState();
  const [enableAnnotation, setEnableAnnotation] = useState(false);
  const [annotationLength, setAnnotationLength] = useState();
  const [sketchfabApi, setSketchfabApi] = useState();
  const [imageArray, setImageArray] = useState([]);
  const mainData = routeData[1].piconeo3;

  useEffect(() => {
    const currentFrame = (index) => `/Image/${mainData.folderName}/${index}.png`;

    const images = [];
    const preloadImages = () => {
      for (let i = 1; i < (mainData.numberOfImage+1); i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      setImageArray(images);
    };

    preloadImages();
  }, []);
  useEffect(() => {
    // Sketchfab Viewer API:  Sync annotation click with user html changes
    var version = "1.12.1";

    var current_anno = -1;
    var annotationsLength;
    var iframe = document.getElementById("api-frame-anno-sync");
    var cameraPosition, cameraTarget;
    var selected = false;
    if (!iframe) {
      console.log("no target");
    }

    //Truck
    // var uid = "312bde93789d482a9eae61826a1610ea";
    //Pico VR
    var uid = mainData.assetId;
    //Room
    // var uid = "11f7f28cd17b4c8592fd7c82ad01dd36";
    function actionSkfb() {
      // initialize

      if (!window.Sketchfab) {
        console.log("no Sketchfab library");
      }
      var client = new window.Sketchfab(version, iframe);
      var error = function error() {
        console.error("Sketchfab API error");
      };
      var success = function success(api) {
        setSketchfabApi(api);
        // CameraConstraints
        function CamConstraints() {
          if (current_anno === 8 || current_anno === 9 || current_anno === 10) {
            api.setEnableCameraConstraints(
              false,
              { preventCameraConstraintsFocus: false },
              function (err) {
                if (!err) {
                  window.console.log("Camera constraints enabled");
                }
              }
            );
          } else {
            api.setEnableCameraConstraints(true, function (err) {
              if (!err) {
                window.console.log("Camera constraints enabled");
              }
            });
            api.setCameraConstraints(
              {
                down: 0.0174533,
                up: 0.0174533,
                left: 0.298132,
                right: 0.698132,
                position: cameraPosition,
                target: cameraTarget,
                useCameraConstraints: true,
                usePanConstraints: true,
                usePitchConstraints: true,
                useYawConstraints: true,
              },
              function (err) {
                console.log(err);
              }
            );
          }
        }
        api.start(function () {});
        api.addEventListener("viewerready", function () {
          api.getCameraLookAt(function (err, camera) {
            cameraPosition = camera.position;
            cameraTarget = camera.target;
          });
          api.addEventListener(
            "click",
            function (info) {
              if (info.instanceID) {

              }
            },
            { pick: "slow" }
          );
          api.addEventListener("camerastart", function () {});

          api.addEventListener("camerastop", function () {

          });
          api.getAnnotationList(function (err, annotations) {
            if (!err) {
              window.annotationLength = Object.keys(annotations).length;
              annotationsLength = annotations.length;
              setAnnotationLength(annotations.length);
              if (annotations.length > 0) {
                setEnableAnnotation(true);
              }
            }
            current_anno = 0;
            setContent(annotations[0]);
            setActiveAnnotation(0 + 1);
            
            api.addEventListener("annotationSelect", function (info) {
              if (info === -1) {
                return;
              }
              current_anno = info;
              setContent(annotations[info]);
              setActiveAnnotation(info + 1);
            });
            api.addEventListener("annotationFocus", function (info) {
              cameraTarget = annotations[info]["target"];
            });
            api.addEventListener("annotationBlur", function (info) {
            });
            api.addEventListener("annotationMouseEnter", function (info) {
            });
            api.addEventListener("annotationMouseLeave", function (info) {
            });
          });

          var url = getNewPastilleURL(
            "rgba(255,255,255,0.0)",
            "black",
            "black",
            "none",
            0,
            50,
            512,
            256
          );

          api.getNodeMap(function (err, nodes) {
            if (!err) {
              //window.console.log("Nodes", nodes); // [ ... ]
              window.node = nodes[50];
              console.log(window.node);
            }
          });

          api.getSceneGraph(function (err, graph) {
            if (!err) {
              window.console.log("Graph", graph); // { ... }
            }
          });

          console.log("viewerready");
        });

        // Annotation Previous vs Next
        document
          .getElementById("annotate-prev-async")
          .addEventListener("click", () => {
            if (current_anno === 0) current_anno = annotationsLength;
            current_anno--;
            setCurrentAnnotation(current_anno + 1);

            api.gotoAnnotation(
              current_anno,
              { preventCameraAnimation: false, preventCameraMove: false },
              function (err, index) {
                if (!err) {
                  window.console.log("Going to annotation", index + 1);
                }
              }
            );
          });
        document
          .getElementById("annotate-next-async")
          .addEventListener("click", () => {
            console.log(activeAnnotation)
            current_anno++;

            if (current_anno === annotationsLength) current_anno = 0;

            setCurrentAnnotation(current_anno + 1);

            api.gotoAnnotation(
              current_anno,
              { preventCameraAnimation: false, preventCameraMove: false },
              function (err, index) {
                if (!err) {
                  window.console.log("Going to annotation", index + 1);
                  // CamConstraints();
                }
              }
            );
          });
      };
      client.init(uid, {
        success: success,
        error: error,
        autostart: 1,
        preload: 0,
        annotation_tooltip_visible: 0, // Usage: Setting to 0 will hide annotations tooltip by default.
        ui_watermark: 0,
        ui_infos: 0,
        ui_controls:0,
        ui_stop:0,
        // scrollwheel: 0,
        // camera: 0,
      });
    }

    actionSkfb();

    //////////////////////////////////
    // GUI Code
    //////////////////////////////////
    function initGui() {
      //   var controls = document.getElementById("controls");
      //   var buttonsText = '\n        <div id="annotations-sync"></div>\n       ';
      //   controls.innerHTML = buttonsText;
    }
    initGui();

    //////////////////////////////////
    // GUI Code end
    //////////////////////////////////

    // pastile image generation

    // Code to create textureimage for pastille from svg
    function computePastilles(
      wCanvas,
      hCanvas,
      bgColor,
      bgBorderColor,
      fgColor,
      fgBorderColor,
      text,
      numHotspot,
      wPastille,
      hPastille
    ) {
      var wSize = wPastille / 10.0;
      var col = wCanvas / wSize;
      var row = hCanvas / wSize;
      var padding = 2;
      var w = wSize - padding;
      var cx;
      var cy = w * 0.5;
      //var cy = 24;

      var ty = cy + 8;
      var pastille = "";
      var num = 0;
      for (var i = 0; i < row; i++) {
        cx = wSize * 0.5;
        for (var k = 0; k < col; k++) {
          num++;
          var letters = text === 0 ? num : text[num];
          var circle = '<circle cx="'
            .concat(cx, '"\n            cy="')
            .concat(cy, '"\n            r="20"\n            fill="')
            .concat(bgColor, '"\n            stroke="')
            .concat(bgBorderColor, '"\n            stroke-width="2"/>');
          var textVG = '<text font-size="26"\n          stroke="'
            .concat(fgBorderColor, '"\n          fill="')
            .concat(
              fgColor,
              '"\n          font-family="sans-serif"\n          text-anchor="middle"\n          alignment-baseline="baseline"\n          x="'
            )
            .concat(cx, '"\n          y="')
            .concat(ty, '">')
            .concat(letters, "</text>");
          pastille += circle + textVG;
          cx += wSize;
        }
        cy += wSize;
        ty += wSize;
      }
      var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      s.setAttribute("version", "1.1");
      s.setAttribute("baseProfile", "full");
      s.setAttribute("width", wPastille);
      s.setAttribute("height", hPastille);
      s.setAttribute(
        "viewBox",
        "0 0 ".concat(wPastille, " ").concat(hPastille)
      );
      s.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      s.innerHTML = pastille;
      // make it base64
      var svg64 = btoa(s.outerHTML);
      var b64Start = "data:image/svg+xml;base64,";
      var image64 = b64Start + svg64;
      var textureOptions = {
        url: image64,
        colNumber: col,
        padding: padding,
        iconSize: w,
      };
      return textureOptions;
    }
    function getNewPastilleURL(
      bgColor,
      bgBorderColor,
      fgColor,
      fgBorderColor,
      text,
      numHotspot,
      w,
      h
    ) {
      var imageData;
      imageData = computePastilles(
        w,
        h,
        bgColor,
        bgBorderColor,
        fgColor,
        fgBorderColor,
        text,
        numHotspot,
        w,
        h
      );
      return imageData;
    }
  }, []);
  return (
    <MDBContainer
      fluid
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <MDBRow
        className="text-center px-1 py-3 annotate-sync-"
        style={{ flex: 1 }}
      >
        <MDBCol xxl="8" md="8" sm="12" lg="8" className="mb-2">
          {" "}
          <iframe
            id="api-frame-anno-sync"
            title="Paracosma"
            frameBorder="0"
            allowFullScreen
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
            allow="autoplay; fullscreen; xr-spatial-tracking;"
            xr-spatial-tracking="true"
            execution-while-out-of-viewport="true"
            execution-while-not-rendered="true"
            web-share="true"
            className="iframe-annotationSync"
          ></iframe>
        </MDBCol>
        <MDBCol
          xxl="4"
          md="4"
          lg="4"
          sm="12"
          className="d-flex flex-column align-content-between px-0"
        >

          {activeAnnotation && (
            <div className="">
              <img
                // src={`/images/pico/${activeAnnotation}.png`}
                src={imageArray[activeAnnotation - 1].src}
                alt="no-extra-info"
                className="pico-img-des img-fluid"
              ></img>
            </div>
          )}
          <div
            className="d-flex justify-content-around align-items-center  mt-2 mb-1 mx-md-5 mx-2"
            style={{ opacity: `${content ? 1 : 0}` }}
          >
            <i
              className="fas fa-chevron-circle-left fs-3  powered-by annotate-button"
              id="annotate-prev-async"
              // onClick={() => prevAnnotate()}
            ></i>
            <div className="annotation-sync-num">{activeAnnotation}</div>
            <i
              className="fas fa-chevron-circle-right fs-3  powered-by annotate-button"
              id="annotate-next-async"
              // onClick={() => nextAnnotate()}
            ></i>
          </div>

          {content ? (
            ""
          ) : (
            <div className="fs-5">
              "Explore Further by Clicking/Tapping on Annotation Hotspots to
              Access Detailed Information."
            </div>
          )}


        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default AnnotationSync;
